<div class="testimonial-container">
  <div class="container my-5 tst-div">
    <h1 class="headline font-weight-bold"
      style="text-align: center; margin-bottom: 20px;font-size: 26px; margin-bottom: 20px;color: #000;text-transform: uppercase;letter-spacing: 1px;">
      Testimonials</h1>
    <div class="row" id="testimonials">
      <!-- First Column -->
      <div class="col-md-4 mb-4 d-flex flex-column justify-content-center">
        <h2 class="headline font-weight-bold mb-3" style="text-align: center !important;">The Greenstar Inn (Near Biju Pattanaik Airport, Bhubaneswar)</h2>
        <p class="intro-text mb-4 text-muted">Here's what our guests are saying...</p>
        <a href="https://search.google.com/local/writereview?placeid=ChIJxXu6peanGToRDwwXqIs4YAo"
          class="btn btn-primary btn-lg writereview">
          <div style="padding-left: 10px;padding-right: 10px; color: white;">
            Write a Review
          </div>
        </a>
      </div>
      <!-- Second Column (Carousel for Desktop) -->
      <div class="col-md-8 mb-4 d-md-block">
        <div class="card shadow-sm border-0 h-100">
          <div id="carouselGreenstarInn" class="carousel slide" data-ride="carousel">
            <div class="carousel-inner c-review-carousel" style="display: block;">
              <div class="carousel-item" data-interval="10000" *ngFor="let item of googleReviews; let i = index"
                [ngClass]="{ 'active': i === 0 }">
                <div class="row">
                  <div class="col-md-12 d-flex justify-content-center">
                    <div class="c-review p-3">
                      <div style="text-align: center;">
                        <div>
                          <img src="assets/images/user.png" alt="{{ item.reviewerName }}"
                            class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;" />
                        </div>
                        <div>
                          <h5 class="font-weight-bold mb-1">{{ item.reviewerName }}</h5>
                        </div>
                        <div>
                          <p class="small text-muted mb-2 c-review-text">{{ item.reviewText }}</p>
                        </div>
                        <div class="star-ratings text-warning">
                          {{ '★'.repeat(item.rating) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Carousel Controls Positioned Outside -->
          <div class="carousel-controls">
            <a class="carousel-control-prev" href="#carouselGreenstarInn" role="button" data-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next" href="#carouselGreenstarInn" role="button" data-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="sr-only">Next</span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="row" id="testimonials">
      <!-- First Column -->
      <div class="col-md-4 mb-4 d-flex flex-column justify-content-center">
        <h2 class="headline font-weight-bold mb-3" style="text-align: center !important;">The Greenstar Inn Premium (Near Sum Hospital, Bhubaneswar)</h2>
        <p class="intro-text mb-4 text-muted" style="text-align: center !important;">Here's what our guests are saying...</p>
        <a href="https://search.google.com/local/writereview?placeid=ChIJD1S0XQAIGToR_LESzokscRc"
          class="btn btn-primary btn-lg writereview"  style="text-align: center !important;">
          <div style="padding-left: 10px;padding-right: 10px; color: white;">
            Write a Review
          </div>
        </a>
      </div>
      <!-- Second Column (Carousel for Desktop) -->
      <div class="col-md-8 mb-4 d-md-block">
        <div class="card shadow-sm border-0 h-100">
          <div id="carouselGreenstarPremium" class="carousel slide" data-ride="carousel">
            <div class="carousel-inner c-review-carousel" style="display: block;">
              <div class="carousel-item" data-interval="10000" *ngFor="let item of googleReviewsOptional; let i = index"
                [ngClass]="{ 'active': i === 0 }">
                <div class="row">
                  <div class="col-md-12 d-flex justify-content-center">
                    <div class="c-review p-3">
                      <div style="text-align: center;">
                        <div>
                          <img src="assets/images/user.png" alt="{{ item.reviewerName }}"
                            class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;" />
                        </div>
                        <div>
                          <h5 class="font-weight-bold mb-1">{{ item.reviewerName }}</h5>
                        </div>
                        <div>
                          <p class="small text-muted mb-2 c-review-text">{{ item.reviewText }}</p>
                        </div>
                        <div class="star-ratings text-warning">
                          {{ '★'.repeat(item.rating) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Carousel Controls Positioned Outside -->
          <div class="carousel-controls">
            <a class="carousel-control-prev" href="#carouselGreenstarPremium" role="button" data-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next" href="#carouselGreenstarPremium" role="button" data-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="sr-only">Next</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
